module.exports = __webpack_public_path__ + "static/icon_slide_arrow_prev-3ddf20b7bda5b27a39557ed86ed881e5.png";